import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthPasswordInput from './AuthPasswordInput';
import { useMobile } from '../../contexts/MobileContext';

import Image from '../../assets/images/login-image.png';

const ResetPasswordPage = () => {
  const { isMobile } = useMobile();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const confirm = () => {
    if (password === confirmPassword) {
      const urlParams = new URLSearchParams(window.location.search);

      fetch(process.env.REACT_APP_SERVER_URL + '/api/set-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': urlParams.get('token')
        },
        body: JSON.stringify({ password })
      })
        .then(response => response.json())
        .then(data => {
          if (data.message === 'invalid token!') {
            console.log('unauthorized access')
            localStorage.removeItem('token');
          }
          navigate('/');
        })
        .catch(error => console.error('Error:', error));
    }
  }

  return (
    <div className={`login${isMobile ? ' single' : ''}`}>
      <form onSubmit={(e) => {
              e.preventDefault();
              confirm();
            }}>
        <h1>Reset Password</h1>

        <AuthPasswordInput label="New Password"
                       placeholder='Enter new password'
                       showWarning={true}
                       onChange={(e) => {
                         setPassword(e.target.value);
                       }}/>

        <AuthPasswordInput label="Confirm Password"
                       placeholder='Confirm new password'
                       showWarning={true}
                       target={password}
                       onChange={(e) => {
                         setConfirmPassword(e.target.value);
                       }}/>

        <button className="button primary auth-button">Confirm</button>
      </form>

      {!isMobile && (
        <img src={Image}
             style={{width: '100%',
                     height: '100%',
                     objectFit: 'cover',
                     borderRadius: '5px',
                    }}
             alt=""/>
      )}

    </div>
  );
}

export default ResetPasswordPage;
